import React, { useCallback } from "react";
import CustomTable, { Column } from "../../components/CustomTable";
import { useLoading } from "../../context/LoadingContext";
import { useAdminContext } from "../../context/AdminContext";
import { createupdateRoleModel, getRoleModel } from "../../model/adminModel";
import StaticModal from "../../components/staticModel";
import { Controller, SubmitHandler, useForm } from "react-hook-form";

const defaultValue = {
  role: "",
};

const RolePage: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<createupdateRoleModel>({ mode: "all", defaultValues: defaultValue });
  const { isLoading } = useLoading();
  const [formType, setFormType] = React.useState<string>("Create");
  const [roleId, setRoleID] = React.useState<number | null>(null);
  const { listRole, getAllRole, getRoleupdate, getRoleCreate } = useAdminContext();

  const columns: Column<getRoleModel>[] = [
    { header: "Role Id", key: "id", enableLink: false, path: "" },
    {
      header: "Role Name",
      key: "role",
      enableLink: true,
      path: "/admin/role",
    },
  ];

  const getRole = useCallback(() => {
    const payload = {
      skip: 0,
      limit: 30,
    };
    getAllRole(payload);
  }, []);

  React.useEffect(() => {
    setValue("role", "");
    getRole();
  }, [getRole]);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setValue("role", "");
    setIsModalOpen(false);
  };

  const handleEdit = (id: number) => {
    if (id) {
      setRoleID(id);
      const roleData = listRole?.filter((item) => item.id === id);
      if (roleData) {
        setFormType("Update");
        setValue("role", roleData[0].role);
        openModal();
      }
    }
  };

  const onSubmit: SubmitHandler<createupdateRoleModel> = async (data) => {
    const Payload: createupdateRoleModel = {
      role: data.role,
    };
    if (formType === "Update" && roleId) {
      await getRoleupdate(roleId, Payload);
      closeModal()
    }
    if (formType === "Create") {
      await getRoleCreate(Payload);
      closeModal()
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <CustomTable
        showFilter={false}
        columns={columns}
        idKeyName='id'
        data={listRole ?? []}
        modelForm={true}
        handleModel={handleEdit}
        handleNavigation={() => {}}
      >
        <button
          onClick={() => {
            setValue('role', '')
            setFormType("Create");
            openModal();
          }}
          className='flex items-center px-4 py-2 text-sm mb-3 bg-gray-900 text-white rounded-lg focus:outline-none hover:bg-gray-600'
        >
          Add Role
        </button>
      </CustomTable>

      <StaticModal headerName={formType + ' Role'} isOpen={isModalOpen} onClose={closeModal}>
        <form
          className='max-w-4xl grid gap-3 grid-cols-1 sm:grid-cols-1 md:grid-cols-1'
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className='mb-2 '>
            <label
              htmlFor='role'
              className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
            >
              Role <span className='text-red-400'>*</span>
            </label>
            <Controller
              name='role'
              control={control}
              rules={{ required: "Role is required" }}
              render={({ field }) => (
                <input
                  {...field}
                  type='text'
                  className='shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light'
                />
              )}
            />
            {errors.role && <p className='text-red-500 text-sm mt-1'>{errors.role.message}</p>}
          </div>
          <div className='max-w-4xl'>
            <button
              type='submit'
              className='text-white bg-blue-700 mr-2 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'
            >
              Save
            </button>
            <button
              type='button'
              onClick={closeModal}
              className='text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800'
            >
              Close
            </button>
          </div>
        </form>
      </StaticModal>
    </div>
  );
};

export default RolePage;
